import { downloadCsv, get, patch, post, remove } from '@/api/base'

const sensorsApi = {
  get: async sensorUuid => {
    const response = await get({
      path: `sensors/${sensorUuid}`,
    })
    return response.success ? response.data.sensor : null
  },
  getAll: async params => {
    const response = await get({
      path: 'sensors',
      params: { ...params },
    })
    return response.success
      ? {
          ...response,
          sensors: response.data.sensors,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  downloadCsv: async companyUuid => {
    await downloadCsv({
      path: 'sensors/csv',
      params: {
        company_uuid: companyUuid,
      },
    })
  },
  update: async (sensorUuid, params) => {
    const response = await patch({
      path: `sensors/${sensorUuid}`,
      params,
    })
    return response.success ? response.data.sensor : null
  },
  create: async params => {
    const response = await post({
      path: `sensors`,
      params,
    })
    return response.success ? response.data.sensor : null
  },
  selectableSensors: async params => {
    const response = await get({
      path: `/sensors/selectable_sensors`,
      params,
    })
    return response.success
      ? {
          ...response,
          sensors: response.data.sensors,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  delete: async sensorUuid => {
    return await remove({
      path: `sensors/${sensorUuid}`,
    })
  },
  selectableSensorTypes: async () => {
    const response = await get({
      path: `/sensors/selectable_types`,
    })
    return response.success ? response.data.types : []
  },
}

export default sensorsApi
